export default __webpack_public_path__ + "static/media/33.27cb449a.png";